import React from "react";
import Box from "@meridian/components/box";
import Text from "@meridian/components/text";
import Column from "@meridian/components/column";
import Divider from "@meridian/components/divider";

export default function Footer(props) {
    return (
        <Column spacing="none" alignmentVertical={"bottom"}>
            <Divider size="small"/>
            <Box spacingInset="400">
                <Text type="b200">
                    {props.children}
                </Text>
            </Box>
            <Divider size="small"/>
        </Column>
    );
}


// WEBPACK FOOTER //
// ./src/components/commons/Footer.js